import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateScanTunnelMutationVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;


export type CreateScanTunnelMutation = { __typename?: 'Mutation', createScanTunnel: { __typename?: 'ScanTunnel', id: string, name: string, mode: Types.ScanTunnelMode } };


export const CreateScanTunnelDocument = gql`
    mutation CreateScanTunnel($name: String!) {
  createScanTunnel(name: $name) {
    id
    name
    mode
  }
}
    `;
export type CreateScanTunnelMutationFn = Apollo.MutationFunction<CreateScanTunnelMutation, CreateScanTunnelMutationVariables>;

/**
 * __useCreateScanTunnelMutation__
 *
 * To run a mutation, you first call `useCreateScanTunnelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScanTunnelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScanTunnelMutation, { data, loading, error }] = useCreateScanTunnelMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateScanTunnelMutation(baseOptions?: Apollo.MutationHookOptions<CreateScanTunnelMutation, CreateScanTunnelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScanTunnelMutation, CreateScanTunnelMutationVariables>(CreateScanTunnelDocument, options);
      }
export type CreateScanTunnelMutationHookResult = ReturnType<typeof useCreateScanTunnelMutation>;
export type CreateScanTunnelMutationResult = Apollo.MutationResult<CreateScanTunnelMutation>;
export type CreateScanTunnelMutationOptions = Apollo.BaseMutationOptions<CreateScanTunnelMutation, CreateScanTunnelMutationVariables>;